<!-- Page wrapper  -->
<!-- ============================================================== -->
<div class="page-wrapper" *ngIf="loaded" [style.margin-top.px]="((layoutManager.mobileMode)?0:60)">
  <!-- ============================================================== -->
  <!-- Container fluid  -->
  <!-- ============================================================== -->
  <div class="container-fluid">
    <!-- ============================================================== -->
    <!-- Slider  -->
    <!-- ============================================================== -->
    <div class="bg-light spacer p-b-0">
      <section id="slider-sec" class="slider4" [style.margin-top.px]="((!layoutManager.smallMode && layoutManager.innerWidth<1000)?120:0)">
        <div id="slider4" class="carousel  indicators-line"  data-interval="7000">

          <!-- Wrapper For Slides -->
          <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
              <!-- Slide Background --><img src="../../assets/images/slide3.jpg" alt="We are Digital Agency" class="slide-image" />
              <!-- Slide Text Layer -->

              <div class="slide-text ">
                <div class="container">
                  <div class="row">
                    <div class="col-md-9 col-lg-6">
                      <label class="font-20" data-animation="animated fadeInDown">Assetstore software dashboard</label>
                      <h2 data-animation="animated fadeInLeft" class="title font-bold m-0 p-b-40">Una gestione di Expert Advisor così non si è mai vista</h2>
                      <ul class="p-0 m-b-40 hidden-sm-down" data-animation="animated fadeInUp">
                        <li><i class="sl-icon-check text-primary m-r-15"></i> Gestisci più software di trading sui tuoi conti</li>
                        <li><i class="sl-icon-check text-primary m-r-15"></i> Utilizza il nostro sistema completamente automatizzato</li>
                        <li><i class="sl-icon-check text-primary m-r-15"></i> VPS incluso nella licenza</li>
                      </ul>
                      <a class="btn btn-1 btn-info-gradiant btn-md btn-arrow" data-animation="animated fadeInLeft"
                         data-toggle="collapse" href="/sign-in" (click)="redirect('sign-in')">
                        <span>Registra un account <i class="ti-arrow-right"></i></span> </a>
                      <a class="btn btn-1 btn-secondary btn-md btn-arrow m-l-20" data-animation="animated fadeInRight" data-toggle="collapse" (click)="scroll(presentazione)">
                        <span>Guarda la presentazione <i class="ti-arrow-right"></i></span> </a>
                    </div>
                  </div>
                </div>
                <p #presentazione></p>
              </div>
            </div>
            <!-- End of Slide -->
            <!-- End of Wrapper For Slides -->
            <!-- Slider Control -->
            <!-- End of Slider Control -->
          </div>
        </div>
        <!-- End Slider -->
      </section>
    </div>
    <!-- ============================================================== -->
    <!-- End Slider 1  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- End Slider code  -->
    <!-- ============================================================== -->
    <br>
    <!--<mat-divider style="margin-left: 7%;margin-right: 7%;"></mat-divider>-->

    <!-- ============================================================== -->
    <!-- Static Slider 2  -->
    <!-- ============================================================== -->
    <div class="static-slider2 spacer">
      <div class="container">
        <!-- Row  -->
        <div class="row">
          <!-- Column -->
          <div class="col-md-5 align-self-center" data-aos="fade-right" data-aos-duration="1200">
            <h6 class="title"></h6>
            <h1 class="title slide-title-1" style="font-size: 60px">
              <span class="text-primary" data-period="2000">{{tmpString}}</span>
              <br><p style="font-size: 65px">VPS</p>
            </h1>
            <h6 class="subtitle">Il supporto dei migliori Trading VPS, attivi 24/h 7/g e configurabili in un minuto nella tua piattaforma utente</h6>
            <a class="btn btn-info-gradiant btn-md btn-arrow m-t-20 m-b-10" data-toggle="collapse" routerLink="/sign-in"><span>Attiva <i class="ti-arrow-right"></i></span></a>
            <a class="btn btn-link btn-md btn-arrow m-t-20 m-b-10 font-medium" data-toggle="collapse" routerLink="/come funziona">
              <span class="underline">Più informazioni <i class="ti-arrow-right"></i></span></a>
          </div>
          <!-- Column -->
          <div class="col-md-7 img-anim" data-aos="fade-up" data-aos-duration="2200" >
            <img src="../../../assets/images/img2.png" alt="wrapkit" class="img-fluid m-t-20 img-rounded" />
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Static Slider 2  -->
    <!-- ============================================================== -->
    <br><br>
    <div class="feature37 wrap-feature38-box spacer">
      <div class="row bg-primary">
        <div class="col-lg-6 po-absolute text-right" style="padding-right: 0;height: 450px" #objCont>
          <img style="width: 650px;" [style.margin-top.px]="objCont.clientHeight/3.5" src="../../assets/images/dashboard-ic.PNG" alt="wrapkit" class="img-fluid" /> </div>
        <div class="container" style="margin-top: 70px">
          <div class="row spacer">
            <div class="col-lg-6">
              <div class="p-20"><span class="label label-success label-rounded">Admin</span>
                <h2 class="title text-white text-uppercase">Scopri come funziona la nostra piattaforma</h2>
                <p class="text-white op-8">Impara ad utilizzare la nostra piattaforma per aggiungere i Consiglieri Esperti sul tuo conto.</p>
                <a class="btn btn-link btn-md btn-arrow m-t-20 m-b-10 font-medium text-white" data-toggle="collapse" (click)="redirect('/come funziona')"
                style="margin-left: -45px; margin-top: -20px">
                  <span class="underline">Più informazioni <i class="ti-arrow-right"></i></span></a>
                <div class="row">
                  <div class="col-md-12">
                    <div class="collapse m-t-20" id="f38">
                      <div class="card card-body card-shadow text-dark">
                        <ul class="nav nav-tabs" id="myTab7" role="tablist">
                          <li class="nav-item">
                            <a class="nav-link active" id="html-tab7" data-toggle="tab" href="#html8" role="tab" aria-controls="html" aria-expanded="true">HTML</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" id="css-tab7" data-toggle="tab" href="#css8" role="tab" aria-controls="css">CSS</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br><br><br>

    <!-- ============================================================== -->
    <!-- Feature 11  -->
    <!-- ============================================================== -->
    <div class="bg-light spacer feature11" style="color: #3e4555;">
      <div class="container">
        <!-- Row  -->
        <div class="row justify-content-center">
          <div class="col-md-7 text-center">
            <h2 class="title" style="color: #3e4555">Esplora il nostro sistema rivoluzionario</h2>
            <h6 class="subtitle">Gestisci nel modo più semplice i tuoi Expert Advisor senza dover effettuare nessuna installazione manuale e nessuna attivazione esterna</h6>
          </div>
        </div>
        <!-- Row  -->
        <div class="row m-t-40">
          <!-- Column -->
          <div class="col-md-4 wrap-feature11-box">
            <div class="card card-shadow" data-aos="fade-right" data-aos-duration="1200">
              <div class="card-body">
                <div class="icon-space">
                  <div class="icon-round bg-success-gradiant"><i class="icon-Shopping-Cart"></i></div>
                </div>
                <h5 class="font-medium">Expert Advisors Market</h5>
                <p class="m-t-20">Sfoglia il catalogo software per trovare quello più adatto alla tua tecnica e alla forma del tuo conto.</p>
              </div>
            </div>
          </div>
          <!-- Column -->
          <div class="col-md-4 wrap-feature11-box">
            <div class="card card-shadow" data-aos="fade-up" data-aos-duration="1200">
              <div class="card-body">
                <div class="icon-space">
                  <div class="icon-round bg-success-gradiant"><i class="icon-Data-Network "></i></div>
                </div>
                <h5 class="font-medium">Configura i software</h5>
                <p class="m-t-20">Configura i software nel VPS attraverso la tua area personale, seleziona gli assets del tuo broker e molto altro.</p>
              </div>
            </div>
          </div>
          <!-- Column -->
          <div class="col-md-4 wrap-feature11-box">
            <div class="card card-shadow" data-aos="fade-left" data-aos-duration="1200">
              <div class="card-body">
                <div class="icon-space">
                  <div class="icon-round bg-success-gradiant"><i class=" icon-Server "></i></div>
                </div>
                <h5 class="font-medium">Utilizza più EA sul tuo conto</h5>
                <p class="m-t-20">Ora i tuoi software opereranno automaticamente nel tuo conto grazie ai nostri VPS.</p>
              </div>
            </div>
          </div>
          <div class="col-md-12 m-t-20 text-center">
            <a class="btn btn-outline-info btn-md btn-arrow" data-toggle="collapse" routerLink="/come funziona"><span>Scopri come funziona <i class="ti-arrow-right"></i></span></a>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Feature 11  -->
    <!-- ============================================================== -->

    <!-- End Feature 8  -->
    <!-- ============================================================== -->
    <div class="bg-white spacer feature8">
      <div class="container">
        <!-- Row -->
        <div class="row">
          <!-- Column -->
          <div class="col-lg-6">
            <br><br>
            <h3>Unisciti al canale Telegram</h3>
            <p style="color: #8d97ad">Resta aggiornato e ricevi importati notifiche</p>
            <ul class="list-block m-b-30">
              <li><i class="sl-icon-check text-info"></i> Canale dimostrativo</li>
              <li><i class="sl-icon-check text-info"></i> Supporto chat 24/h 7/g</li>
              <li><i class="sl-icon-check text-info"></i> Bot collegati al proprio Expert Advisor per usufruire di ulteriori funzionalità</li>
              <li><i class="sl-icon-check text-info"></i> Notifiche su apertra/chiusura delle operazioni</li>
            </ul>
            <a (click)="telegramRedirect()"
              class="btn btn-outline-primary btn-md btn-arrow text-primary btn-telegram" data-toggle="collapse"
                 href="https://t.me/autoassets"><span>Unisciti alla Chat <i class="ti-arrow-right"></i></span></a>

          </div>
          <!-- Column -->
          <div class="col-lg-6">
            <div class="p-20">
              <img src="../../../assets/images/telegram5.jpg" alt="wrapkit" class="img-responsive img-shadow img-rounded"
                   (click)="telegramRedirect()"
                   data-aos="flip-right" data-aos-duration="1200" style="margin-top: 50px;" />
            </div>
          </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Feature 8  -->
    <!-- ============================================================== -->




      <!-- ============================================================== -->
    <!-- Feature 39  -->
    <!-- ============================================================== -->
    <div class="feature39 spacer wrap-feature39-box">
      <div class="container">
        <div class="row">
          <div class="col-lg-6"><img src="../../../assets/images/paypal.jpg" class="img-fluid img-rounded" alt="wrapkit" style="margin-top: 50px"/></div>
          <div class="col-lg-6">
            <div class="card-body">
              <!--<h2 class="title text-uppercase">Awesome Extra Ordinary Flexibility</h2>
              <p class="m-t-40 m-b-40">You can relay on our amazing features list and also our customer services will be greatexperience for you without</p>-->
              <!-- column  -->
              <br><br><br><br>
              <div class="d-flex no-block m-b-40">
                <div class="display-4 m-r-20"><i class="icon-Paypal text-info-gradiant"></i></div>
                <div>
                  <h4>Pagamenti sicuri con Paypal</h4>
                  <h6 class="subtitle">Paga in facilità tramite paypal</h6>
                </div>
              </div>
              <!-- column  -->
              <div class="d-flex no-block m-b-40">
                <div class="display-4 m-r-20"><i class="icon-Credit-Card2 text-info-gradiant"></i></div>
                <div>
                  <h4>Carte</h4>
                  <h6 class="subtitle">Usa la tua carta di credito in sicurezza</h6>
                </div>
              </div>
              <!-- column  -->
              <div class="d-flex no-block m-b-40">
                <div class="display-4 m-r-20"><i class="icon-File-Cloud text-info-gradiant"></i></div>
                <div>
                  <h4>Fatture rimborsabili</h4>
                  <h6 class="subtitle">Fatti rimborsare le fatture dal nostro broker convenzionato</h6>
                </div>
              </div> <a class="btn btn-outline-info btn-md btn-arrow" data-toggle="collapse" href="#f39" (click)="partnersRedirect()">
              <span>Scopri di più <i class="ti-arrow-right"></i></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- Feature 39  -->
    <!-- ============================================================== -->

      <!-- ============================================================== -->
      <!-- Feature 3  -->
      <!-- ============================================================== -->
      <div class="bg-light spacer feature3">
        <div class="container">
          <!-- Row  -->
          <div class="row justify-content-center">
            <div class="col-md-7 text-center">
              <h2 class="title" style="color: #3e4555!important;">Controlla l'operato dei nostri software su MyFxBook</h2>
              <h6 class="subtitle">FxBook è un sistema di analisi che permette di analizzare e rappresentare l'operato
                di trading per un conto ad esso associato, sfoglia i report dei nostri principali software</h6>
            </div>
          </div>
          <!-- Row  -->
          <div class="row m-t-40" style="color: #3e4555!important;">
            <!-- Column -->
            <div class="col-md-6 wrap-feature3-box">
              <div class="card card-shadow" data-aos="fade-right" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space align-self-center"><i class=" icon-Bar-Chart  display-2 text-primary"></i></div>
                  <div class="align-self-center row-assets">
                    <h5 class="font-medium"><a href="https://www.myfxbook.com/members/ilmarna/expertrsi/7706095/TMzaYeIGD3jgxhrgx7wh" class="linking"
                    >AssetRsi <i class="ti-arrow-right"></i></a></h5>
                    <p class="m-t-20">Controlla AssetRsi su MyFxBook, uno dei software più rilevanti di AssetX.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-6 wrap-feature3-box">
              <div class="card card-shadow" data-aos="fade-left" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space align-self-center"><i class="icon-Bar-Chart display-2 text-primary"></i></div>
                  <div class="align-self-center row-assets">
                    <h5 class="font-medium"><a href="https://www.myfxbook.com/members/ilmarna/expert-max-new/7792153/qhYMyhtFBSwKCqhWsJ0n"
                                               class="linking">AssetMax <i class="ti-arrow-right"></i></a></h5>
                    <p class="m-t-20">Controlla AssetMax su MyFxBook uno dei software più testati e utilizzati di AssetX.</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-6 wrap-feature3-box">
              <div class="card card-shadow" data-aos="fade-right" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space align-self-center"><i class="icon-Bar-Chart display-2 text-primary"></i></div>
                  <div class="align-self-center row-assets">
                    <h5 class="font-medium"><a href="javascript:void(0)" class="linking">AssetAdx <i class="ti-arrow-right"></i></a></h5>
                    <p class="m-t-20">In arrivo...</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Column -->
            <!-- Column -->
            <div class="col-md-6 wrap-feature3-box">
              <div class="card card-shadow" data-aos="fade-left" data-aos-duration="1200">
                <div class="card-body d-flex">
                  <div class="icon-space align-self-center"><i class="icon-Bar-Chart display-2 text-primary"></i></div>
                  <div class="align-self-center row-assets">
                    <h5 class="font-medium"><a href="https://www.myfxbook.com/members/ilmarna/expert-mid/7792573/3nDsN9F4YGhOLIvYc2Pl"
                                               class="linking">AssetRsiMid <i class="ti-arrow-right"></i></a></h5>
                    <p class="m-t-20">Controlla AssetRsiMid su MyFxBook, uno dei software più rilevanti di AssetX.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Feature 3  -->
      <!-- ============================================================== -->

  </div>
  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Back to top -->
  <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Page wrapper  -->
<!-- ============================================================== -->
<!-- ============================================================== -->
</div>
